import { withSchema } from '@websolutespa/bom-core';
import { Checkbox as CheckboxBase } from './checkbox';
import { CheckboxGroup } from './checkbox-group';
import { CheckboxGroupLabel } from './checkbox-group-label';
import { CheckboxIcon } from './checkbox-icon';

export const Checkbox = withSchema(
  CheckboxBase,
  {
    Icon: CheckboxIcon,
    Group: CheckboxGroup,
    GroupLabel: CheckboxGroupLabel,
  }
);

export type { CheckboxProps } from './checkbox';
export type { CheckboxGroupProps } from './checkbox-group';
export type { CheckboxGroupLabelProps } from './checkbox-group-label';
export type { CheckboxIconProps } from './checkbox-icon';

export * from './checkbox.variants';

